import {PricingPlan} from '../models/pricing-plan.model';
import {createReducer, on} from '@ngrx/store';
import {PricingPlanActions} from './action-types';


export interface PricingPlansState {
  monthlyPlan: PricingPlan;
  /**
   * OPTIONAL, and undefined for every school that has not opted into quarterly billing.
   *
   * Marked optional rather than added to the required trio because the vast majority of
   * tenant documents predate it: `pricingPlansLoaded` copies whatever the tenant holds,
   * and for those schools that is `undefined`. The subscription screen skips a plan it
   * has no data for, so nobody grows a fourth card by upgrading.
   */
  quarterlyPlan?: PricingPlan;
  yearlyPlan: PricingPlan;
  lifetimePlan: PricingPlan;
}


export const initialState: PricingPlansState = {
  monthlyPlan: undefined,
  quarterlyPlan: undefined,
  yearlyPlan: undefined,
  lifetimePlan: undefined
};


export const pricingPlansReducer = createReducer(
  initialState,

  on(PricingPlanActions.pricingPlansLoaded, (state,action) => {
    return {
      ...state,
      lifetimePlan: action.pricingPlans.lifetimePlan,
      yearlyPlan: action.pricingPlans.yearlyPlan,
      quarterlyPlan: action.pricingPlans.quarterlyPlan,
      monthlyPlan: action.pricingPlans.monthlyPlan
    };
  }),

  on(PricingPlanActions.updatePricingPlan, (state, action) => {
    const newState = {...state};

    const newPlan = {
      ...newState[action.planName],
      ...action.changes
    };

    newState[action.planName] = newPlan;

    return newState;
  })

);
